<template>
    <div class="flex-container bg-white tg-fixed-tabBar" v-show="data">
        <div v-text="data.items[0].title" class="fs-14 padding10 marginr10 text-dark tg-fixed-tabBar_item" @click="itemClick(data,0)" :class="{'active':0==activeIndex}" :data-scp="$options.name+'.0'" v-if="data.items[0].title"></div>
        <div class="scroll-container flex1">
            <span v-for="item in data.items[0].items" class="fs-14 paddingh10 marginr10 text-dark tg-fixed-tabBar_item" :data-scp="$options.name+'.'+$index+1" @click="itemClick(item,$index+1)" :class="{'active':($index+1)==activeIndex}"><span v-text="item.title" class="paddingv10"></span></span>
        </div>
        <div class="paddingh20 pos-r" @click="scrollNext" v-if="showArrow">
            <div style="position: absolute;
        left: -30px;
        top: -0.13333333rem;
        bottom: -0.13333333rem;
        width: 30px;
        background-image: -webkit-linear-gradient(left, transparent, white);
        background-image: linear-gradient(to right, transparent, white);
        background-image: -webkit-linear-gradient(to right, transparent, white);
        background-image: -webkit-gradient(linear,0 50%,100% 50%,from(rgba(255,255,255,0)),to(#fff));
        pointer-events:none"></div>
            <i class="icon icon-right" style="display: block"></i>
        </div>
    </div>
</template>
<script>
import _ from '_';
import $ from 'jquery';
var itemParamName;
function setItemParamNameByData(data){
    itemParamName=_.get(data,'items[0].items[0].params')
    if(itemParamName){
        itemParamName=itemParamName.split('=')[0]
    }
}
export default{
    props:{
        data:{
            type:Object,
            default:null
        },
        target:{
            type:Object,
            default:{}
        },
        color:{
            type:String,
            default:'red'
        },
        showArrow:{
            type:Boolean,
            default:true
        }
    },
    ready(){
        if(!this.$el.id){
            this.$el.id=_.uniqueId('tgFixedTabbar_');
        }
        this.$dispatch('initFixedTabComponent',this,this.activeIndex);
    },
    data(){
        var _this=this
        ,   activeIndex
        ,   FixedTabIndex=+maple.url().params.FixedTabIndex
        ;
        setItemParamNameByData(this.data)
        if(FixedTabIndex){
            activeIndex=FixedTabIndex
        }else{
            activeIndex=_.get(this.data,'items[0].title')?0:1;
        }
        return {
            activeIndex
        }
    },
    watch:{
        data(newValue){
            setItemParamNameByData(newValue)
            this.activeIndex=+maple.url().params.FixedTabIndex||(_.get(newValue,'items[0].title')?0:1);
            var activeDom=$(this.$el).find('.active')[0];
            activeDom&&activeDom.scrollIntoView(false);
        }
    },
    methods:{
        itemClick(item,index){
            if(this.activeIndex==index){
                return
            }
            var currentIndex=this.activeIndex
            ,   httpUrl=this.data.baseUrl
            ,   params=item.params
            ,   replaceParams={FixedTabIndex:index}
            ,   paramsArr=params&&params.split('=')
            ;
            if(paramsArr){
                replaceParams[paramsArr[0]]=paramsArr[1]
            }
            if(params){
                httpUrl+='&'+params
            }
            this.activeIndex=index;
            if(!maple.device.weixin){
                maple.url().replace(replaceParams);
                if(!paramsArr&&itemParamName){
                    maple.url().replace(itemParamName,'');
                }
            }
            this.$dispatch('loadFixedTabComponent',httpUrl,index,currentIndex,replaceParams);
        },
        scrollNext(){
            var dom=$(this.$el).find('.scroll-container');
            var left=dom.scrollLeft();
            var dis=dom.find('.tg-fixed-tabBar_item').outerWidth(true)
            dom.animate({'scrollLeft':left+dis})
        }
    }
}
</script>
<style lang="scss">
    .tg-fixed-tabBar_item.active{
        color:#ff4c48;
    }
</style>